import useSubscribeNotifications from './useSubscribeNotifications'
import { Notification, NotificationEntity } from '../types'
import { isEntityNotification } from '../utils/notification'

type NotificationHandler = (notification: Notification<NotificationEntity>) => void

export default function useSubscribeEntityNotifications(handle: NotificationHandler) {
  useSubscribeNotifications((notification) => {
    if (isEntityNotification(notification)) {
      handle(notification as Notification<NotificationEntity>)
    }
  })
}
